import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AiDe_LE from './AiDe_LE';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <AiDe_LE Code={"LEAD"} SchulerCode={98765432} Klassenstufe={1}/>
  </React.StrictMode>
);


